import React, { PureComponent } from 'react';
import ReactTable from 'react-table';
import styled from 'styled-components';
import { TableWrapper } from 'modules/list/table';

const PricingTableWrapper = styled(TableWrapper)`
  padding-left: 0px;
  padding-right: 0px;
`;

const width = 140;

export default class CourseInfo extends PureComponent {
  render() {
    const { courseInfo } = this.props;
    const tableColumns = [
      {
        columns: [
          {
            Header: 'Course Name',
            accessor: 'name',
          },
          {
            Header: 'Enrollment Type',
            accessor: 'enrollment_type',
            width,
          },
          {
            Header: 'Grade',
            accessor: 'grade_band',
          },
          {
            Header: 'Duration in months',
            accessor: 'dynamic_duration',
            width,
          },
          {
            Header: 'Class ratio',
            accessor: 'dynamic_class_ratio',
          },
          {
            Header: 'Classes Per Week',
            accessor: 'dynamic_classes_per_week',
            width,
          },
          {
            Header: 'Access Type',
            accessor: 'access_type',
            width,
          },
        ],
      },
    ];

    return (
      <React.Fragment>
        <PricingTableWrapper>
          <ReactTable
            data={courseInfo}
            className="-striped -highlight"
            manual
            showPaginationTop
            showPageSizeOptions={false}
            filterable={false}
            sortable={false}
            resizable={true}
            defaultPageSize={1}
            columns={tableColumns}
            style={{ textAlign: 'center' }}
          />
        </PricingTableWrapper>
      </React.Fragment>
    );
  }
}
